import React, { useMemo, useContext } from "react";
import { getSystemSettings } from "../functions/Functions"
import { SettingsContext } from "../contexts/Settings";

export const useGeneralHooks = () => {
  const { generalSettings } = useContext(SettingsContext);

  const getFlag = (key) => parseInt(getSystemSettings(generalSettings, key)) === 1;
  const getFlagValue = (key) => getSystemSettings(generalSettings, key);

  const { 
    isFoodsInn, 
    piBackDate, 
    dayEndCash,
    itemWiseDiscount,
    csvPassword,
    taxType,
    digitalMenuQr,
    onlineOrderEdit,
    isOrderNo,
    denominationConfirmation,
    dayEndStockMandatory,
    issueQtyLock,
    autoSettleFp,
    disableFpOrderRing,
    multiOrderSettle,
    selfOrderCheck,
    managerDayOpen,
    menuWisePrice,
    zreportPosActivity,
    salesListingKey,
    enableStockBrand,
    isIssuanceAmountView,
    isDayEndStockEmail,
    hideWastageRecipe
  } = useMemo(() => ({
    isFoodsInn: generalSettings && getFlag("foods_in_setting"),
    piBackDate: generalSettings && getFlag("pi_back_date"),
    dayEndCash: generalSettings && getFlag("day_end_cash"),
    itemWiseDiscount: generalSettings && getFlag("item_wise_discount"),
    csvPassword: generalSettings && getFlagValue("csv_password"),
    onlineOrderEdit: generalSettings && getFlag("online_order_edit"),
    taxType: generalSettings && getFlagValue("tax_type"),
    isOrderNo: generalSettings && getFlag("order_no"),
    denominationConfirmation: generalSettings && getFlag("denomination_confirmation"),
    dayEndStockMandatory: generalSettings && getFlag("day_end_stock_mandatory"),
    issueQtyLock: generalSettings && getFlag("issue_qty_lock"),
    autoSettleFp: generalSettings && getFlag("auto_settle_fp"),
    disableFpOrderRing: generalSettings && getFlag("disable_fp_order_ring"),
    multiOrderSettle: generalSettings && getFlag("multi_order_settle"),
    digitalMenuQr: generalSettings && getFlag("digital_menu_qr"),
    selfOrderCheck: generalSettings && getFlag("self_order_check"),
    managerDayOpen: generalSettings && getFlag("day_open"),
    menuWisePrice: generalSettings && getFlag("menu_wise_rate"),
    zreportPosActivity: generalSettings && getFlag("zreport_pos_activity"),
    salesListingKey: generalSettings && getFlagValue("sales_listing_key"),
    enableStockBrand: generalSettings && getFlag("fifo_stock_enable"),
    isIssuanceAmountView: generalSettings && getFlag("issuance_amount_view"),
    isDayEndStockEmail: generalSettings && getFlag("day_end_stock_email"),
    hideWastageRecipe: generalSettings && getFlag("hide_wastage_recipe"),
  }), [generalSettings]);

  return { 
    isFoodsInn,
    piBackDate,
    dayEndCash,
    itemWiseDiscount,
    csvPassword,
    onlineOrderEdit,
    taxType,
    isOrderNo,
    denominationConfirmation,
    dayEndStockMandatory,
    issueQtyLock,
    autoSettleFp,
    disableFpOrderRing,
    multiOrderSettle,
    digitalMenuQr,
    selfOrderCheck,
    managerDayOpen,
    menuWisePrice,
    zreportPosActivity,
    salesListingKey,
    enableStockBrand,
    isIssuanceAmountView,
    isDayEndStockEmail,
    hideWastageRecipe
  };
};